export const legacySchedulingPanelStyles = (/* components, theme */) => ({
  '& .row': {
    marginLeft: 0,
  },
  '& label.accordion': {
    '& a': {
      '& span.expandedImage, span.expanderImage': {
        marginLeft: 0,
        marginRight: 8,
      },
    },
  },
});
